import React, { Fragment } from 'react';
import { Divider, Grid, List } from '@mui/material';
import AssetRow from './AssetRow';
// import './index.css';

const AssetSelect = ({
    locationId,
    setChecked,
    assets,
    assetIdsForReport,
}) => {
    const half_way = Math.floor(assets.length / 2);
    const list_1 = assets.slice(0, half_way);
    const list_2 = assets.slice(half_way);
    return (
        <Grid
            container
            direction="row"
            alignItems="center"
            height="30vh"
            overflow='auto'
            className='cylinderList'
        >
            <Grid item xs={6} md={6} lg={6}>
                <List>
                    {list_1.map((asset, index) => (
                        <Fragment key={index}>
                            <AssetRow
                                locationId={locationId}
                                name={asset.name}
                                setChecked={setChecked}
                                assetId={asset.id}
                                assetIdsForReport={assetIdsForReport}
                                asset={asset}
                            />
                            <Divider variant="middle" />
                        </Fragment>
                    ))}
                </List>
            </Grid>

            <Grid item xs={6} md={6} lg={6}>
                <List>
                    {list_2.map((asset, index) => (
                        <Fragment key={index}>
                            <AssetRow
                                locationId={locationId}
                                name={asset.name}
                                setChecked={setChecked}
                                assetId={asset.id}
                                assetIdsForReport={assetIdsForReport}
                                asset={asset}
                            />
                            <Divider variant="middle" />
                        </Fragment>
                    ))}
                </List>
            </Grid>
        </Grid>
    );
}; 

export default AssetSelect;
